import { postJson, getJson } from './http';
import type { IssuedTokens, AuthIdentity } from '@/types';

export interface LoginPayload {
  loginName: string;
  password: string;
}

export function login(payload: LoginPayload): Promise<IssuedTokens> {
  return postJson<IssuedTokens, LoginPayload>('/auth/login', payload);
}

export function refresh(refreshToken: string): Promise<IssuedTokens> {
  return postJson<IssuedTokens, { refreshToken: string }>('/auth/refresh', { refreshToken });
}

export function logout(accessToken: string): Promise<void> {
  return postJson<void, { accessToken: string }>('/auth/logout', { accessToken });
}

export function fetchMe(): Promise<AuthIdentity> {
  return getJson<AuthIdentity>('/auth/me');
}

export function changePassword(payload: {
  oldPassword: string;
  newPassword: string;
}): Promise<void> {
  return postJson<void, typeof payload>('/auth/change-password', payload);
}
